const INPUT_SEARCH_TITLE = "INPUT_SEARCH_TITLE"
const INPUT_SEARCH_PLACEHOLDER = "INPUT_SEARCH_PLACEHOLDER"
const GLYCEMIC_INDEX_OF = "GLYCEMIC_INDEX_OF"
const GLYCEMIC_LOAD_OF = "GLYCEMIC_LOAD_OF"
const PER_SERVING_OF = "PER_SERVING_OF"
const GRAM = "GRAM"
const TABS_SECTION_TITLE = "TABS_SECTION_TITLE"
const GLYCEMIC_INDEX_TAB = "GLYCEMIC_INDEX_TAB"
const GLYCEMIC_LOAD_TAB = "GLYCEMIC_LOAD_TAB"
const FOODS_WITH_GLYCEMIC_INDEX_BETWEEN = "FOODS_WITH_GLYCEMIC_INDEX_BETWEEN"
const FOOD_SEARCH_BUTTON = "FOOD_SEARCH_BUTTON"
const FOODS_WITH_GLYCEMIC_LOAD_BETWEEN = "FOODS_WITH_GLYCEMIC_LOAD_BETWEEN"
const FOOD_DRINK = "FOOD_DRINK"
const GI = "GI"
const GLUCOSE = "GLUCOSE"
const PORTION = "PORTION"
const GL = "GL"
const LOW_GLYCEMIC_INDEX = "LOW_GLYCEMIC_INDEX"
const AVERAGE_GLYCEMIC_INDEX = "AVERAGE_GLYCEMIC_INDEX"
const HIGH_GLYCEMIC_INDEX = "HIGH_GLYCEMIC_INDEX"
const CARBOHYDRATES = "CARBOHYDRATES"
const CALORIE_CALCULATOR_TITLE = "CALORIE_CALCULATOR_TITLE"
const CALORIE_CALCULATOR_DESCRIPTION = "CALORIE_CALCULATOR_DESCRIPTION"
const MY_UNITS = "MY_UNITS"
const IMPERIAL = "IMPERIAL"
const METRIC = "METRIC"
const WHAT_IS_YOUR_GENDER = "WHAT_IS_YOUR_GENDER"
const MALE = "MALE"
const FEMALE = "FEMALE"
const WHAT_IS_YOUR_WEIGHT = "WHAT_IS_YOUR_WEIGHT"
const KG = "KG"
const LB = "LB"
const WHAT_IS_YOUR_HEIGHT = "WHAT_IS_YOUR_HEIGHT"
const SM = "SM"
const FEET = "FEET"
const WHAT_IS_YOUR_AGE = "WHAT_IS_YOUR_AGE"
const WHICH_SENTENCE_BEST_DESCRIBES_YOUR_DAILY_ACTIVITY_LEVEL =
  "WHICH_SENTENCE_BEST_DESCRIBES_YOUR_DAILY_ACTIVITY_LEVEL"
const SEATED_MOST_OF_THE_DAY = "SEATED_MOST_OF_THE_DAY"
const STANDING_ABOUT_HALF_THE_TIME = "STANDING_ABOUT_HALF_THE_TIME"
const WALKING_ABOUT_HALF_THE_TIME = "WALKING_ABOUT_HALF_THE_TIME"
const CONSTANTLY_ON_THE_MOVE = "CONSTANTLY_ON_THE_MOVE"
const WHICH_MATCHES_YOUR_LEVEL_OF_PHYSICAL_ACTIVITY =
  "WHICH_MATCHES_YOUR_LEVEL_OF_PHYSICAL_ACTIVITY"
const GET_RESULTS_BUTTON = "GET_RESULTS_BUTTON"
const DAILY_RECOMMENDED_CALORIES = "DAILY_RECOMMENDED_CALORIES"
const RECOMMENDED_TEXT = "RECOMMENDED_TEXT"
const TRY_CALCULATOR_AGAIN_BUTTON = "TRY_CALCULATOR_AGAIN_BUTTON"
const KG_POPUP = "KG_POPUP"
const LB_POPUP = "LB_POPUP"
const SM_POPUP = "SM_POPUP"
const FEET_POPUP = "FEET_POPUP"
const YEARS = "YEARS"
const YEARS_POPUP = "YEARS_POPUP"
const SLIDER_VALUE_0 = "SLIDER_VALUE_0"
const SLIDER_VALUE_1 = "SLIDER_VALUE_1"
const SLIDER_VALUE_2 = "SLIDER_VALUE_2"
const SLIDER_VALUE_0_TEXT = "SLIDER_VALUE_0_TEXT"
const SLIDER_VALUE_1_TEXT = "SLIDER_VALUE_1_TEXT"
const SLIDER_VALUE_2_TEXT = "SLIDER_VALUE_2_TEXT"
const SECTION_TITLE = "SECTION_TITLE"
const KG_CM = "KG_CM"
const LBS_INCH = "LBS_INCH"
const WEIGHT = "WEIGHT"
const HEIGHT = "HEIGHT"
const KG_BMI = "KG_BMI"
const CM = "CM"
const LBS = "LBS"
const INCH = "INCH"
const CALCULATE_BUTTON = "CALCULATE_BUTTON"
const RECOMMENDATION_UNDER_18_5 = "RECOMMENDATION_UNDER_18_5"
const RECOMMENDATION_OVER_18_5_UNDER_24_9 =
  "RECOMMENDATION_OVER_18_5_UNDER_24_9"
const RECOMMENDATION_OVER_24_9_UNDER_29_9 =
  "RECOMMENDATION_OVER_24_9_UNDER_29_9"
const RECOMMENDATION_OVER_29_9_UNDER_34_9 =
  "RECOMMENDATION_OVER_29_9_UNDER_34_9"
const RECOMMENDATION_OVER_34_9_UNDER_39_9 =
  "RECOMMENDATION_OVER_34_9_UNDER_39_9"
const RECOMMENDATION_OVER_39_9 = "RECOMMENDATION_OVER_39_9"
const CONTACT_WITH_EXPERT = "CONTACT_WITH_EXPERT"
const CONTACT_WITH_EXPERT_URL_I = "CONTACT_WITH_EXPERT_URL_I"
const CONTACT_WITH_EXPERT_URL_II = "CONTACT_WITH_EXPERT_URL_II"
const MORE_ADVICES_BUTTON = "MORE_ADVICES_BUTTON"
const ADVICES_FOR_HEALTHY_LIFE_BUTTON = "ADVICES_FOR_HEALTHY_LIFE_BUTTON"

//Header beggining

//Header end

// 404

const PAGE_NOT_HOME_PAGE = "PAGE_NOT_HOME_PAGE"
const PAGE_NOT_FOUND = "PAGE_NOT_FOUND"

// Frst Steps

const FIRST_STEPS_PLS_ACPT_TERMS = "FIRST_STEPS_PLS_ACPT_TERMS"
const FIRST_STEPS_PLS_VAL_EMAIL = "FIRST_STEPS_PLS_VAL_EMAIL"
const FIRST_STEPS_REQ_FLD = "FIRST_STEPS_REQ_FLD"

// Response Modal

const FIRST_STEPS_RM_TNX_BETA = "FIRST_STEPS_RM_TNX_BETA"
const FIRST_STEPS_RM_TNX_MSG = "FIRST_STEPS_RM_TNX_MSG"

// First Steps - Form

const FIRST_STEPS_FORM_PRIVACY_POLICY = "FIRST_STEPS_FORM_PRIVACY_POLICY"
const FIRST_STEPS_FORM_READ_AND_AGREE = "FIRST_STEPS_FORM_READ_AND_AGREE"
const FIRST_STEPS_FORM_YES_SUBSCRIBE = "FIRST_STEPS_FORM_YES_SUBSCRIBE"
const FIRST_STEPS_FORM_UR_EMAIL = "FIRST_STEPS_FORM_UR_EMAIL"
const FIRST_STEPS_FORM_UR_NAME = "FIRST_STEPS_FORM_UR_NAME"
const FIRST_STEPS_FORM_SUBMIT = "FIRST_STEPS_FORM_SUBMIT"
const FIRST_STEPS_FORM_TERMS = "FIRST_STEPS_FORM_TERMS"
const FIRST_STEPS_FORM_AND = "FIRST_STEPS_FORM_AND"
const FIRST_STEPS_FORM_FS = "FIRST_STEPS_FORM_FS"

// Index (Home Page)

// Index Calculators Info Section
const INDEX_CALC_INFO_FOUR_FREE = "INDEX_CALC_INFO_FOUR_FREE"
const INDEX_CALC_TOOLS_FOR_HELP = "INDEX_CALC_TOOLS_FOR_HELP"
const INDEX_CALC_TOOLS_DESC = "INDEX_CALC_TOOLS_DESC"
const INDEX_CALC_INFO_FREE = "INDEX_CALC_INFO_FREE"

// Index Healthy Life Section
const INDEX_HLTH_LIFE_HEALTHY_LIFE = "INDEX_HLTH_LIFE_HEALTHY_LIFE"
const INDEX_HLTH_LIFE_U_WANT_LEAD = "INDEX_HLTH_LIFE_U_WANT_LEAD"
const INDEX_HLTH_LIFE_DESC = "INDEX_HLTH_LIFE_DESC"
const INDEX_HLTH_LIFE_FIRST_STEPS_BTR_LIFE =
  "INDEX_HLTH_LIFE_FIRST_STEPS_BTR_LIFE"

// Index Calculators Info Section (Cards)
const INDEX_CALC_INFO_WHATS_BEST_WEIGHT = "INDEX_CALC_INFO_WHATS_BEST_WEIGHT"
const INDEX_CALC_INFO_DAILY_CAL_INTAKE = "INDEX_CALC_INFO_DAILY_CAL_INTAKE"
const INDEX_CALC_INFO_FOOD_NAV_II = "INDEX_CALC_INFO_FOOD_NAV_II"
const INDEX_CALC_INFO_FOOD_U_NEED = "INDEX_CALC_INFO_FOOD_U_NEED"
const INDEX_CALC_INFO_FOOD_NAV_I = "INDEX_CALC_INFO_FOOD_NAV_I"
const INDEX_CALC_INFO_GLIC_INDEX = "INDEX_CALC_INFO_GLIC_INDEX"
const INDEX_CALC_INFO_CAL_CALC = "INDEX_CALC_INFO_CAL_CALC"
const INDEX_CALC_INFO_SEE_MORE = "INDEX_CALC_INFO_SEE_MORE"
const INDEX_CALC_INFO_BMI = "INDEX_CALC_INFO_BMI"

// Index Review Slider
const INDEX_CALC_REWIEW_IVET_STORY = "INDEX_CALC_REWIEW_IVET_STORY"
const INDEX_CALC_REWIEW_JAY_STORY = "INDEX_CALC_REWIEW_JAY_STORY"
const INDEX_CALC_REWIEW_YI_STORY = "INDEX_CALC_REWIEW_YI_STORY"
const INDEX_CALC_REWIEW_URL_III = "INDEX_CALC_REWIEW_URL_III"
const INDEX_CALC_REWIEW_URL_II = "INDEX_CALC_REWIEW_URL_II"
const INDEX_CALC_REWIEW_URL_I = "INDEX_CALC_REWIEW_URL_I"
const INDEX_CALC_REWIEW_IVET = "INDEX_CALC_REWIEW_IVET"
const INDEX_CALC_REWIEW_JAY = "INDEX_CALC_REWIEW_JAY"
const INDEX_CALC_REWIEW_YI = "INDEX_CALC_REWIEW_YI"

// Index - Review Wrapper
const INDEX_CALC_STORIES = "INDEX_CALC_STORIES"
const INDEX_BLOG_WRPR_HLP_FR_U = "INDEX_BLOG_WRPR_HLP_FR_U"

// Index - For Diabetes Section
const INDEX_DIABETES_DIAGNOSED_COUNT = "INDEX_DIABETES_DIAGNOSED_COUNT"
const INDEX_DIABETES_AFFECTED_COUNT = "INDEX_DIABETES_AFFECTED_COUNT"
const INDEX_DIABETES_DEAD_COUNT = "INDEX_DIABETES_DEAD_COUNT"
const INDEX_DIABETES_SUGAR_DEAD = "INDEX_DIABETES_SUGAR_DEAD"
const INDEX_DIABETES_DIAGNOSED = "INDEX_DIABETES_DIAGNOSED"
const INDEX_DIABETES_AFFECTED = "INDEX_DIABETES_AFFECTED"
const INDEX_DIABETES_SUGAR = "INDEX_DIABETES_SUGAR"
const INDEX_DIABETES_DESC = "INDEX_DIABETES_DESC"
const INDEX_DIABETES_DEAD = "INDEX_DIABETES_DEAD"

// Index - Hero Section
const INDEX_HERO_HERE_TO_HELP = "INDEX_HERO_HERE_TO_HELP"
const INDEX_HERO_NEW_DIAGNOSE = "INDEX_HERO_NEW_DIAGNOSE"
const INDEX_HERO_FIRST_STEPS = "INDEX_HERO_FIRST_STEPS"
const INDEX_HERO_FREE_GUIDE = "INDEX_HERO_FREE_GUIDE"

// Header
const HEADER_CALCULATORS = "HEADER_CALCULATORS"
const HEADER_DIABETIC = "HEADER_DIABETIC"
const HEADER_DOCTORS = "HEADER_DOCTORS"
const HEADER_MAIN = "HEADER_MAIN"
const HEADER_BLOG = "HEADER_BLOG"

// Footer
const FOOTER_ABOUT_COMNY = "FOOTER_ABOUT_COMNY"
const FOOTER_ABOUT_US = "FOOTER_ABOUT_US"
const FOOTER_CARIERS = "FOOTER_CARIERS"
const FOOTER_CONTACT_US = "FOOTER_CONTACT_US"
const FOOTER_HELP_CENTRE = "FOOTER_HELP_CENTRE"
const FOOTER_BLOG = "FOOTER_BLOG"
const FOOTER_FAQ = "FOOTER_FAQ"
const FOOTER_LEGAL = "FOOTER_LEGAL"
const FOOTER_TERMS = "FOOTER_TERMS"
const FOOTER_PRIVACY = "FOOTER_PRIVACY"
const FOOTER_COOKIES = "FOOTER_COOKIES"
const FOOTER_SERVICES = "FOOTER_SERVICES"
const FOOTER_TOOLS = "FOOTER_TOOLS"
const FOOTER_DOC_NETWORK = "FOOTER_DOC_NETWORK"
const FOOTER_DIABETICS = "FOOTER_DIABETICS"
const FOOTER_PODCASTS = "FOOTER_PODCASTS"
const FOOTER_HELP = "FOOTER_HELP"

// home Consultation Desc

const HOME_CONSULT_DESC_SPEC_OFFER = "HOME_CONSULT_DESC_SPEC_OFFER"
const HOME_CONSULT_DESC_FREE = "HOME_CONSULT_DESC_FREE"
const HOME_CONSULT_DESC_CONSULTATION = "HOME_CONSULT_DESC_CONSULTATION"
const HOME_CONSULT_DESC_MED_PRO = "HOME_CONSULT_DESC_MED_PRO"
const HOME_CONSULT_DESC_TEXT = "HOME_CONSULT_DESC_TEXT"
const HOME_CONSULT_DESC_ONEHUND_PRO = "HOME_CONSULT_DESC_ONEHUND_PRO"
const HOME_CONSULT_DESC_NO_SPAM = "HOME_CONSULT_DESC_NO_SPAM"
const HOME_CONSULT_DESC_ANON = "HOME_CONSULT_DESC_ANON"
const HOME_CONSULT_DESC_PDF = "HOME_CONSULT_DESC_PDF"

// For Diabetics

// For Diabetics - Help Section

const DIABETICS_HLP_SECTION_HEALTH_PRO = "DIABETICS_HLP_SECTION_HEALTH_PRO"
const DIABETICS_HLP_SECTION_TEXT = "DIABETICS_HLP_SECTION_TEXT"
const DIABETICS_HLP_SECTION_SIGN_UP = "DIABETICS_HLP_SECTION_SIGN_UP"

// For Diabetics - How it Works

const DIABETICS_HIW_EASY_STEPS = "DIABETICS_HIW_EASY_STEPS"
const DIABETICS_HIW_ALWAYS_IN_CONTACT = "DIABETICS_HIW_ALWAYS_IN_CONTACT"
const DIABETICS_HIW_AIC_TEXT = "DIABETICS_HIW_AIC_TEXT"
const DIABETICS_HIW_PIC_A_PRO = "DIABETICS_HIW_PIC_A_PRO"
const DIABETICS_HIW_PAP_TEXT = "DIABETICS_HIW_PAP_TEXT"
const DIABETICS_HIW_TRANSPARANCY = "DIABETICS_HIW_TRANSPARANCY"
const DIABETICS_HIW_DIABETICS_HIW_TRANSPARANCY_TEXT =
  "DIABETICS_HIW_DIABETICS_HIW_TRANSPARANCY_TEXT"

// For Diabetics - Online Consultation

const DIABETICS_OC_EASY_SECURE_FAST = "DIABETICS_OC_EASY_SECURE_FAST"
const DIABETICS_OC_ESF_TEXT = "DIABETICS_OC_ESF_TEXT"
const DIABETICS_OC_EASY_ACCESS = "DIABETICS_OC_EASY_ACCESS"
const DIABETICS_OC_EA_TEXT = "DIABETICS_OC_EA_TEXT"
const DIABETICS_OC_SYNC = "DIABETICS_OC_SYNC"
const DIABETICS_OC_SYNC_TEXT = "DIABETICS_OC_SYNC_TEXT"
const DIABETICS_OC_SIGN_UP = "DIABETICS_OC_SIGN_UP"
const DIABETICS_HIW = "DIABETICS_HIW"

// For Diabetics - APP Section

const DIABETICS_APP_GET_TO_KNOW = "DIABETICS_APP_GET_TO_KNOW"
const DIABETICS_APP_DESC = "DIABETICS_APP_DESC"
const DIABETICS_APP_EASY = "DIABETICS_APP_EASY"
const DIABETICS_APP_EASY_TEXT = "DIABETICS_APP_EASY_TEXT"
const DIABETICS_APP_CONVENIENT = "DIABETICS_APP_CONVENIENT"
const DIABETICS_APP_CONVENIENT_TEXT = "DIABETICS_APP_CONVENIENT_TEXT"
const DIABETICS_APP_TRANSPARENT = "DIABETICS_APP_TRANSPARENT"
const DIABETICS_APP_TRANSPARENT_TEXT = "DIABETICS_APP_TRANSPARENT_TEXT"
const DIABETICS_APP_SECURE = "DIABETICS_APP_SECURE"
const DIABETICS_APP_SECURE_TEXT = "DIABETICS_APP_SECURE_TEXT"
const DIABETICS_APP_NO_CASH = "DIABETICS_APP_NO_CASH"
const DIABETICS_APP_NO_CASH_TEXT = "DIABETICS_APP_NO_CASH_TEXT"
const DIABETICS_APP_INDV_SEG = "DIABETICS_APP_INDV_SEG"
const DIABETICS_APP_INDV_SEG_TEXT = "DIABETICS_APP_INDV_SEG_TEXT"

// For Diabetics - Newsletter

const DIABETICS_NEWSLTTR_FREE_TIPS = "DIABETICS_NEWSLTTR_FREE_TIPS"
const DIABETICS_NEWSLTTR_HOW_TO_PICK = "DIABETICS_NEWSLTTR_HOW_TO_PICK"
const DIABETICS_NEWSLTTR_FREE = "DIABETICS_NEWSLTTR_FREE"
const DIABETICS_NEWSLTTR_TIPS = "DIABETICS_NEWSLTTR_TIPS"
const DIABETICS_NEWSLTTR_SUBSCRIBE = "DIABETICS_NEWSLTTR_SUBSCRIBE"

// For Health Coaches

// For Health Coaches - Header section

const HLTH_COACH_HEADER_PROFIT = "HLTH_COACH_HEADER_PROFIT"
const HLTH_COACH_HEADER_DESC = "HLTH_COACH_HEADER_DESC"
const HLTH_COACH_HEADER_FREE_ACS = "HLTH_COACH_HEADER_FREE_ACS"

// For Health Coaches - Features

const HLTH_COACH_FEAT_NEW_PACI = "HLTH_COACH_FEAT_NEW_PACI"
const HLTH_COACH_FEAT_REACH_WORLD = "HLTH_COACH_FEAT_REACH_WORLD"
const HLTH_COACH_FEAT_AUTO_WORK = "HLTH_COACH_FEAT_AUTO_WORK"
const HLTH_COACH_FEAT_FASTER_BETTER = "HLTH_COACH_FEAT_FASTER_BETTER"
const HLTH_COACH_FEAT_ONLINE = "HLTH_COACH_FEAT_ONLINE"
const HLTH_COACH_FEAT_SCHEDULE = "HLTH_COACH_FEAT_SCHEDULE"
const HLTH_COACH_FEAT_TRUE_FEEDBACK = "HLTH_COACH_FEAT_TRUE_FEEDBACK"
const HLTH_COACH_FEAT_RATE = "HLTH_COACH_FEAT_RATE"

// For Health Coaches - Training

const HLTH_COACH_TRAINING_ONLINE_COUNSULTATION =
  "HLTH_COACH_TRAINING_ONLINE_COUNSULTATION"
const HLTH_COACH_TRAINING_INCOME = "HLTH_COACH_TRAINING_INCOME"
const HLTH_COACH_TRAINING_INCOME_TEXT = "HLTH_COACH_TRAINING_INCOME_TEXT"
const HLTH_COACH_TRAINING_SCHEDULE = "HLTH_COACH_TRAINING_SCHEDULE"
const HLTH_COACH_TRAINING_SCHEDULE_TEXT = "HLTH_COACH_TRAINING_SCHEDULE_TEXT"
const HLTH_COACH_TRAINING_CONSULTATION = "HLTH_COACH_TRAINING_CONSULTATION"
const HLTH_COACH_TRAINING_CONSULTATION_TEXT =
  "HLTH_COACH_TRAINING_CONSULTATION_TEXT"

// For Health Coaches - Help Section

const HLTH_COACH_HELP_HELP_PPL = "HLTH_COACH_HELP_HELP_PPL"
const HLTH_COACH_HELP_REACH_THE_WORLD = "HLTH_COACH_HELP_REACH_THE_WORLD"
const HLTH_COACH_HELP_LEARN_MORE = "HLTH_COACH_HELP_LEARN_MORE"
const HLTH_COACH_HELP_PROFIT = "HLTH_COACH_HELP_PROFIT"
const HLTH_COACH_HELP_DR_HRISTO = "HLTH_COACH_HELP_DR_HRISTO"
const HLTH_COACH_HELP_DOC = "HLTH_COACH_HELP_DOC"

// For Health Coaches - Prices

const HLTH_COACH_PRICE_TALK_IN_NUM = "HLTH_COACH_PRICE_TALK_IN_NUM"
const HLTH_COACH_PRICE_TIN_TEXT = "HLTH_COACH_PRICE_TIN_TEXT"
const HLTH_COACH_PRICE_PRECENT_I = "HLTH_COACH_PRICE_PRECENT_I"
const HLTH_COACH_PRICE_I_TEXT = "HLTH_COACH_PRICE_I_TEXT"
const HLTH_COACH_PRICE_PRECENT_II = "HLTH_COACH_PRICE_PRECENT_II"
const HLTH_COACH_PRICE_II_TEXT = "HLTH_COACH_PRICE_II_TEXT"
const HLTH_COACH_PRICE_PRECENT_III = "HLTH_COACH_PRICE_PRECENT_III"
const HLTH_COACH_PRICE_III_TEXT = "HLTH_COACH_PRICE_III_TEXT"
const HLTH_COACH_PRICE_PRECENT_IV = "HLTH_COACH_PRICE_PRECENT_IV"
const HLTH_COACH_PRICE_IV_TEXT = "HLTH_COACH_PRICE_IV_TEXT"

// For Health Coaches - Key Features

const HLTH_COACH_KEY_FEATURES_KEY_FEATURES =
  "HLTH_COACH_KEY_FEATURES_KEY_FEATURES"
const HLTH_COACH_KEY_FEATURES_ONLINE_CALENDAR =
  "HLTH_COACH_KEY_FEATURES_ONLINE_CALENDAR"
const HLTH_COACH_KEY_FEATURES_CAL_TEXT = "HLTH_COACH_KEY_FEATURES_CAL_TEXT"
const HLTH_COACH_KEY_FEATURES_YOU_ARE = "HLTH_COACH_KEY_FEATURES_YOU_ARE"
const HLTH_COACH_KEY_FEATURES_YOU_ARE_TEXT =
  "HLTH_COACH_KEY_FEATURES_YOU_ARE_TEXT"
const HLTH_COACH_KEY_FEATURES_FOLLOW_INOVATIONS =
  "HLTH_COACH_KEY_FEATURES_FOLLOW_INOVATIONS"
const HLTH_COACH_KEY_FEATURES_INOVATION_TEXT =
  "HLTH_COACH_KEY_FEATURES_INOVATION_TEXT"
const HLTH_COACH_KEY_FEATURES_WORK_FROM_HOME =
  "HLTH_COACH_KEY_FEATURES_WORK_FROM_HOME"

// Blog

const BLOG_NEW = "BLOG_NEW"
const BLOG_MOST_READ = "BLOG_MOST_READ"
const BLOG_CATEGORIES = "BLOG_CATEGORIES"

// BMI

const BMI_EMAIL_SCS = "BMI_EMAIL_SCS"
const BMI_EMAIL_INV = "BMI_EMAIL_INV"
const BMI_EMAIL_USD = "BMI_EMAIL_USD"
const BMI_BMI = "BMI_BMI"

const BMI_FEAT_URL_I = "BMI_FEAT_URL_I"
const BMI_FEAT_URL_II = "BMI_FEAT_URL_II"
const BMI_FEAT_URL_III = "BMI_FEAT_URL_III"
const BMI_FEAT_URL_IV = "BMI_FEAT_URL_IV"

// BMI - Header

const BMI_HEADER_MAIN_TEXT = "BMI_HEADER_MAIN_TEXT"
const BMI_HEADER_MASS = "BMI_HEADER_MASS"
const BMI_HEADER_CALC = "BMI_HEADER_CALC"

// BMI - Features

const BMI_FEAT_RES = "BMI_FEAT_RES"
const BMI_FEAT_MESURE = "BMI_FEAT_MESURE"
const BMI_FEAT_WHAT_IS_ITM = "BMI_FEAT_WHAT_IS_ITM"
const BMI_FEAT_USE_EFECTIVE = "BMI_FEAT_USE_EFECTIVE"
const BMI_FEAT_READ_MORE = "BMI_FEAT_READ_MORE"
const BMI_FEAT_PERFECT_WEIGHT = "BMI_FEAT_PERFECT_WEIGHT"
const BMI_FEAT_HOW_TO_ITM = "BMI_FEAT_HOW_TO_ITM"
const BMI_FEAT_ITM_FLAWS = "BMI_FEAT_ITM_FLAWS"
const BMI_FEAT_HOW_TO_USE = "BMI_FEAT_HOW_TO_USE"
const BMI_FEAT_EXSAMPLE = "BMI_FEAT_EXSAMPLE"
const BMI_FEAT_EXSAMPLE_EASY = "BMI_FEAT_EXSAMPLE_EASY"

// Calorie Features Section

const CAL_CALC_FEAT_USEFULL = "CAL_CALC_FEAT_USEFULL"
const CAL_CALC_FEAT_CAL_INTAKE = "CAL_CALC_FEAT_CAL_INTAKE"
const CAL_CALC_FEAT_WHAT_CAL = "CAL_CALC_FEAT_WHAT_CAL"
const CAL_CALC_FEAT_LEARN_WHAT_CAL = "CAL_CALC_FEAT_LEARN_WHAT_CAL"
const CAL_CALC_FEAT_LEARN_MORE = "CAL_CALC_FEAT_LEARN_MORE"
const CAL_CALC_FEAT_CAL_BURN = "CAL_CALC_FEAT_CAL_BURN"
const CAL_CALC_FEAT_LEARN_CAL_BURN = "CAL_CALC_FEAT_LEARN_CAL_BURN"
const CAL_CALC_FEAT_HOW_MUCH_CAL = "CAL_CALC_FEAT_HOW_MUCH_CAL"
const CAL_CALC_FEAT_LEARN_HOW_MUCH_CAL = "CAL_CALC_FEAT_LEARN_HOW_MUCH_CA"
const CAL_CALC_FEAT_TYPES = "CAL_CALC_FEAT_TYPES"
const CAL_CALC_FEAT_SORCE = "CAL_CALC_FEAT_SORCE"
const CAL_CALC_FEAT_QAL = "CAL_CALC_FEAT_QAL"

const CAL_CALC_URL_I = "CAL_CALC_URL_I"
const CAL_CALC_URL_II = "CAL_CALC_URL_II"
const CAL_CALC_URL_III = "CAL_CALC_URL_III"
const CAL_CALC_URL_IV = "CAL_CALC_URL_IV"

// MISC

const CAL_CALC_SUB_TEXT = "CAL_CALC_SUB_TEXT"
const CAL_CALC_TEXT = "CAL_CALC_TEXT"
const CAL_CALC_TITLE = "CAL_CALC_TITLE"
const NUTRITION_TEXT = "NUTRITION_TEXT"
const GL_CALC_SUB_TEXT = "GL_CALC_SUB_TEXT"
const GL_CALC_TEXT = "GL_CALC_TEXT"
const GL_CALC_TITLE = "GL_CALC_TITLE"

// Nutrition

const NUTRITION_URI_I = "NUTRITION_URI_I"
const NUTRITION_URI_II = "NUTRITION_URI_II"
const NUTRITION_URI_III = "NUTRITION_URI_III"
const NUTRITION_URI_IV = "NUTRITION_URI_IV"

const NUTRITION_INPUT = "NUTRITION_INPUT"

const NUTRITION_CONTAINER_SUB_TEXT = "NUTRITION_CONTAINER_SUB_TEXT"
const NUTRITION_CONTAINER_TEXT = "NUTRITION_CONTAINER_TEXT"
const NUTRITION_CONTAINER_TITE = "NUTRITION_CONTAINER_TITE"

const NUTRITION_FEATURES_RESORS = "NUTRITION_FEATURES_RESORS "
const NUTRITION_FEATURES_AMOUNT = "NUTRITION_FEATURES_AMOUNT"
const NUTRITION_FEATURES_HOW_TO = "NUTRITION_FEATURES_HOW_TO"
const NUTRITION_FEATURES_WHAT_INFO = "NUTRITION_FEATURES_WHAT_INFO"
const NUTRITION_FEATURES_READ_MORE = "NUTRITION_FEATURES_READ_MORE"
const NUTRITION_FEATURES_MACROS = "NUTRITION_FEATURES_MACROS"
const NUTRITION_FEATURES_IMPORTANT_FOOD = "NUTRITION_FEATURES_IMPORTANT_FOOD"
const NUTRITION_FEATURES_RECOMENDS = "NUTRITION_FEATURES_RECOMENDS"
const NUTRITION_FEATURES_COMMON_FOODS = "NUTRITION_FEATURES_COMMON_FOODS"
const NUTRITION_FEATURES_RECOMEND_COMBOS = "NUTRITION_FEATURES_RECOMEND_COMBOS"
const NUTRITION_FEATURES_RECOMEND_COMBOS_TIPS =
  "NUTRITION_FEATURES_RECOMEND_COMBOS_TIPS"

// CL Calculator

const GI_CALC_URL_I = "GI_CALC_URL_I"
const GI_CALC_URL_II = "GI_CALC_URL_II"
const GI_CALC_URL_III = "GI_CALC_URL_III"
const GI_CALC_URL_IV = "GI_CALC_URL_IV"

const GI_CALC_USEFULL_RES = "GI_CALC_USEFULL_RES"
const GI_CALC_CARBS = "GI_CALC_CARBS"
const GI_CALC_WHAT_ARE_CARBS = "GI_CALC_WHAT_ARE_CARBS"
const GI_CALC_LEARN_CARBS = "GI_CALC_LEARN_CARBS"
const GI_CALC_LEARN_MORE = "GI_CALC_LEARN_MORE"
const GI_CALC_PICK_CARBS = "GI_CALC_PICK_CARBS"
const GI_CALC_PICK_CARBS_FOR_U = "GI_CALC_PICK_CARBS_FOR_U"
const GI_CALC_FOOD_CATEG = "GI_CALC_FOOD_CATEG"
const GI_CALC_HIGH_LOW_GL = "GI_CALC_HIGH_LOW_GL"
const GI_CALC_GL_ENOUGH = "GI_CALC_GL_ENOUGH"
const GI_CALC_IMPORTANT_QUESTION = "GI_CALC_IMPORTANT_QUESTION"

// Cacl Page

const CALC_PAGE_WELCOME = "CALC_PAGE_WELCOME"
const CALC_PAGE_U_ARE_NEW = "CALC_PAGE_U_ARE_NEW"
const CALC_PAGE_U_ARE_OLD = "CALC_PAGE_U_ARE_OLD"
const CALC_PAGE_WIGHT_PROBLEMS = "CALC_PAGE_WIGHT_PROBLEMS"
const CALC_PAGE_U_WANT_BETTER_WEIGHT = "CALC_PAGE_U_WANT_BETTER_WEIGHT"
const CALC_PAGE_CALCS = "CALC_PAGE_CALCS"
const CALC_PAGE_MAX_HELP = "CALC_PAGE_MAX_HELP"
const CALC_PAGE_FIRST_CALC = "CALC_PAGE_FIRST_CALC"
const CALC_PAGE_FIRST_CALC_TEXT = "CALC_PAGE_FIRST_CALC_TEXT"
const CALC_PAGE_CAL_CALC = "CALC_PAGE_CAL_CALC"
const CALC_PAGE_LOSE_KILOS = "CALC_PAGE_LOSE_KILOS"
const CALC_PAGE_KEEP_KILOS = "CALC_PAGE_KEEP_KILOS"
const CALC_PAGE_GAIN_KILOS = "CALC_PAGE_GAIN_KILOS"
const CALC_PAGE_CAL_CALC_TEXT = "CALC_PAGE_CAL_CALC_TEXT"
const CALC_PAGE_TEXT_I = "CALC_PAGE_TEXT_I"
const CALC_PAGE_HOW_TO_USE_CALCS = "CALC_PAGE_HOW_TO_USE_CALCS"
const CALC_PAGE_CALCS_EXPLAIN = "CALC_PAGE_CALCS_EXPLAIN"
const CALC_PAGE_STEPS = "CALC_PAGE_STEPS"
const CALC_PAGE_STEP_INDEX = "CALC_PAGE_STEP_INDEX"
const CALC_PAGE_STEP_CAL = "CALC_PAGE_STEP_CAL"
const CALC_PAGE_STEP_MACROS = "CALC_PAGE_STEP_MACROS"
const CALC_PAGE_TEXT_II = "CALC_PAGE_TEXT_II"
const CALC_PAGE_TEXT_III = "CALC_PAGE_TEXT_III"
const CALC_PAGE_TEXT_IV = "CALC_PAGE_TEXT_IV"
const CALC_PAGE_TEXT_V = "CALC_PAGE_TEXT_V"

// Sub Form

const SUB_FORM_U_WANT = "SUB_FORM_U_WANT"
const SUB_FORM_DESC = "SUB_FORM_DESC"

// Blog Preview

const BLOG_PREVIEW_FORM_U_WANT = "BLOG_PREVIEW_FORM_U_WANT"
const BLOG_PREVIEW_FORM_JOIN_CLUB = "BLOG_PREVIEW_FORM_JOIN_CLUB"
const BLOG_PREVIEW_FORM_FREE = "BLOG_PREVIEW_FORM_FREE"
const BLOG_PREVIEW_FORM_RES = "BLOG_PREVIEW_FORM_RES"
const BLOG_PREVIEW_FORM_SUECURE = "BLOG_PREVIEW_FORM_SUECURE"
const BLOG_PREVIEW_FORM_NO_SPAM = "BLOG_PREVIEW_FORM_NO_SPAM"
const BLOG_PREVIEW_FORM_ANON = "BLOG_PREVIEW_FORM_ANON"
const BLOG_PREVIEW_FORM_PDF = "BLOG_PREVIEW_FORM_PDF"
const BLOG_PREVIEW_FORM_SIGN_UP = "BLOG_PREVIEW_FORM_SIGN_UP"

// Specialist Sub

const SPECIALIST_SUB_NAME = "SPECIALIST_SUB_NAME"
const SPECIALIST_SUB_EMAIL = "SPECIALIST_SUB_EMAIL"
const SPECIALIST_SUB_ABOUT = "SPECIALIST_SUB_ABOUT"
const SPECIALIST_SUB_MSG = "SPECIALIST_SUB_MSG"
const SPECIALIST_SUB_ACS = "SPECIALIST_SUB_ACS"
const SPECIALIST_SUB_TERMS = "SPECIALIST_SUB_TERMS"
const SPECIALIST_SUB_TEAM = "SPECIALIST_SUB_TEAM"
const SPECIALIST_SUB_SEND = "SPECIALIST_SUB_SEND"
const SPECIALIST_SUB_AND = "SPECIALIST_SUB_AND"
const SPECIALIST_SUB_USE_TERMS = "SPECIALIST_SUB_USE_TERMS"
const SPECILIST_SUB_ABOUT = "SPECILIST_SUB_ABOUT"
const SPECILIST_SUB_WRAPPER = "SPECILIST_SUB_WRAPPER"

// SEO

const BLOG_META_TITLE = "BLOG_META_TITLE"
const BLOG_META_DESCRIPTION = "BLOG_META_DESCRIPTION"
const BMI_CALCULATOR_META_TITLE = "BMI_CALCULATOR_META_TITLE"
const BMI_CALCULATOR_META_DESCRIPTION = "BMI_CALCULATOR_META_DESCRIPTION"
const CALCULATORS_PAGE_META_TITLE = "CALCULATORS_PAGE_META_TITLE"
const CALCULATORS_PAGE_META_DESCRIPTION = "CALCULATORS_PAGE_META_DESCRIPTION"
const CALORIE_CALCULATOR_META_TITLE = "CALORIE_CALCULATOR_META_TITLE"
const CALORIE_CALCULATOR_META_DESCRIPTION =
  "CALORIE_CALCULATOR_META_DESCRIPTION"
const CONTACTS_PAGE_META_TITLE = "CONTACTS_PAGE_META_TITLE"
const CONTACTS_PAGE_META_DESCRIPTION = "CONTACTS_PAGE_META_DESCRIPTION"
const FIRST_STEPS_META_TITLE = "FIRST_STEPS_META_TITLE"
const FIRST_STEPS_META_DESCRIPTION = "FIRST_STEPS_META_DESCRIPTION"
const FOR_DIABETICS_META_TITLE = "FOR_DIABETICS_META_TITLE"
const FOR_DIABETICS_META_DESCRIPTION = "FOR_DIABETICS_META_DESCRIPTION"
const FOR_HEALTH_COACH_META_TITLE = "FOR_HEALTH_COACH_META_TITLE"
const FOR_HEALTH_COACH_META_DESCRIPTION = "FOR_HEALTH_COACH_META_DESCRIPTION"
const GL_CALCULATOR_META_TITLE = "GL_CALCULATOR_META_TITLE"
const GL_CALCULATOR_META_DESCRIPTION = "GL_CALCULATOR_META_DESCRIPTION"
const HOME_PAGE_META_TITLE = "HOME_PAGE_META_TITLE"
const HOME_PAGE_META_DESCRIPTION = "HOME_PAGE_META_DESCRIPTION"
const NUTRITION_CALCULATOR_META_TITLE = "NUTRITION_CALCULATOR_META_TITLE"
const NUTRITION_CALCULATOR_META_DESCRIPTION =
  "NUTRITION_CALCULATOR_META_DESCRIPTION"
const SPECIALIST_SUBSCRIPTION_META_TITLE = "SPECIALIST_SUBSCRIPTION_META_TITLE"
const SPECIALIST_SUBSCRIPTION_META_DESCRIPTION =
  "SPECIALIST_SUBSCRIPTION_META_DESCRIPTION"
const SUBSCRIPTION_META_TITLE = "SUBSCRIPTION_META_TITLE"
const SUBSCRIPTION_META_DESCRIPTION = "SUBSCRIPTION_META_DESCRIPTION"

export default {
  SUBSCRIPTION_META_DESCRIPTION,
  SUBSCRIPTION_META_TITLE,
  SPECIALIST_SUBSCRIPTION_META_DESCRIPTION,
  SPECIALIST_SUBSCRIPTION_META_TITLE,
  NUTRITION_CALCULATOR_META_DESCRIPTION,
  NUTRITION_CALCULATOR_META_TITLE,
  HOME_PAGE_META_DESCRIPTION,
  HOME_PAGE_META_TITLE,
  GL_CALCULATOR_META_DESCRIPTION,
  GL_CALCULATOR_META_TITLE,
  FOR_HEALTH_COACH_META_DESCRIPTION,
  FOR_HEALTH_COACH_META_TITLE,
  FOR_DIABETICS_META_DESCRIPTION,
  FOR_DIABETICS_META_TITLE,
  FIRST_STEPS_META_DESCRIPTION,
  FIRST_STEPS_META_TITLE,
  CONTACTS_PAGE_META_DESCRIPTION,
  CONTACTS_PAGE_META_TITLE,
  CALORIE_CALCULATOR_META_DESCRIPTION,
  CALORIE_CALCULATOR_META_TITLE,
  CALCULATORS_PAGE_META_TITLE,
  CALCULATORS_PAGE_META_DESCRIPTION,
  BLOG_META_TITLE,
  BLOG_META_DESCRIPTION,
  BMI_CALCULATOR_META_TITLE,
  BMI_CALCULATOR_META_DESCRIPTION,
  CONTACT_WITH_EXPERT_URL_I,
  CONTACT_WITH_EXPERT_URL_II,
  WHICH_SENTENCE_BEST_DESCRIBES_YOUR_DAILY_ACTIVITY_LEVEL,
  DIABETICS_HIW_DIABETICS_HIW_TRANSPARANCY_TEXT,
  WHICH_MATCHES_YOUR_LEVEL_OF_PHYSICAL_ACTIVITY,
  HLTH_COACH_KEY_FEATURES_FOLLOW_INOVATIONS,
  HLTH_COACH_TRAINING_ONLINE_COUNSULTATION,
  NUTRITION_FEATURES_RECOMEND_COMBOS_TIPS,
  HLTH_COACH_KEY_FEATURES_ONLINE_CALENDAR,
  HLTH_COACH_KEY_FEATURES_WORK_FROM_HOME,
  HLTH_COACH_KEY_FEATURES_INOVATION_TEXT,
  HLTH_COACH_TRAINING_CONSULTATION_TEXT,
  HLTH_COACH_KEY_FEATURES_KEY_FEATURES,
  HLTH_COACH_KEY_FEATURES_YOU_ARE_TEXT,
  INDEX_HLTH_LIFE_FIRST_STEPS_BTR_LIFE,
  RECOMMENDATION_OVER_34_9_UNDER_39_9,
  RECOMMENDATION_OVER_29_9_UNDER_34_9,
  RECOMMENDATION_OVER_24_9_UNDER_29_9,
  RECOMMENDATION_OVER_18_5_UNDER_24_9,
  NUTRITION_FEATURES_RECOMEND_COMBOS,
  NUTRITION_FEATURES_IMPORTANT_FOOD,
  HLTH_COACH_TRAINING_SCHEDULE_TEXT,
  INDEX_CALC_INFO_WHATS_BEST_WEIGHT,
  FOODS_WITH_GLYCEMIC_INDEX_BETWEEN,
  CAL_CALC_FEAT_LEARN_HOW_MUCH_CAL,
  HLTH_COACH_KEY_FEATURES_CAL_TEXT,
  HLTH_COACH_TRAINING_CONSULTATION,
  DIABETICS_HLP_SECTION_HEALTH_PRO,
  INDEX_CALC_INFO_DAILY_CAL_INTAKE,
  FOODS_WITH_GLYCEMIC_LOAD_BETWEEN,
  NUTRITION_FEATURES_COMMON_FOODS,
  HLTH_COACH_KEY_FEATURES_YOU_ARE,
  HLTH_COACH_HELP_REACH_THE_WORLD,
  HLTH_COACH_TRAINING_INCOME_TEXT,
  DIABETICS_HIW_ALWAYS_IN_CONTACT,
  FIRST_STEPS_FORM_READ_AND_AGREE,
  FIRST_STEPS_FORM_PRIVACY_POLICY,
  ADVICES_FOR_HEALTHY_LIFE_BUTTON,
  CALC_PAGE_U_WANT_BETTER_WEIGHT,
  DIABETICS_NEWSLTTR_HOW_TO_PICK,
  DIABETICS_APP_TRANSPARENT_TEXT,
  HOME_CONSULT_DESC_CONSULTATION,
  INDEX_DIABETES_DIAGNOSED_COUNT,
  FIRST_STEPS_FORM_YES_SUBSCRIBE,
  CALORIE_CALCULATOR_DESCRIPTION,
  HLTH_COACH_FEAT_FASTER_BETTER,
  HLTH_COACH_FEAT_TRUE_FEEDBACK,
  DIABETICS_APP_CONVENIENT_TEXT,
  DIABETICS_OC_EASY_SECURE_FAST,
  DIABETICS_HLP_SECTION_SIGN_UP,
  HOME_CONSULT_DESC_ONEHUND_PRO,
  INDEX_DIABETES_AFFECTED_COUNT,
  NUTRITION_FEATURES_WHAT_INFO,
  NUTRITION_FEATURES_READ_MORE,
  NUTRITION_FEATURES_RECOMENDS,
  NUTRITION_CONTAINER_SUB_TEXT,
  CAL_CALC_FEAT_LEARN_WHAT_CAL,
  CAL_CALC_FEAT_LEARN_CAL_BURN,

  HLTH_COACH_PRICE_TALK_IN_NUM,
  HLTH_COACH_PRICE_PRECENT_III,
  HLTH_COACH_TRAINING_SCHEDULE,
  DIABETICS_NEWSLTTR_FREE_TIPS,
  DIABETICS_NEWSLTTR_SUBSCRIBE,
  HOME_CONSULT_DESC_SPEC_OFFER,
  INDEX_CALC_REWIEW_IVET_STORY,
  INDEX_HLTH_LIFE_HEALTHY_LIFE,
  STANDING_ABOUT_HALF_THE_TIME,
  BLOG_PREVIEW_FORM_JOIN_CLUB,
  HLTH_COACH_PRICE_PRECENT_II,
  HLTH_COACH_PRICE_PRECENT_IV,
  HLTH_COACH_FEAT_REACH_WORLD,
  DIABETICS_APP_INDV_SEG_TEXT,
  INDEX_CALC_REWIEW_JAY_STORY,
  INDEX_CALC_INFO_FOOD_U_NEED,
  INDEX_CALC_INFO_FOOD_NAV_II,
  INDEX_HLTH_LIFE_U_WANT_LEAD,
  WALKING_ABOUT_HALF_THE_TIME,
  TRY_CALCULATOR_AGAIN_BUTTON,
  CALC_PAGE_HOW_TO_USE_CALCS,
  GI_CALC_IMPORTANT_QUESTION,
  CAL_CALC_FEAT_HOW_MUCH_CAL,
  HLTH_COACH_PRICE_PRECENT_I,
  HLTH_COACH_HELP_LEARN_MORE,
  HLTH_COACH_TRAINING_INCOME,
  HLTH_COACH_HEADER_FREE_ACS,
  DIABETICS_APP_NO_CASH_TEXT,
  DIABETICS_HIW_TRANSPARANCY,
  DIABETICS_HLP_SECTION_TEXT,
  INDEX_CALC_REWIEW_YI_STORY,
  INDEX_CALC_INFO_GLIC_INDEX,
  INDEX_CALC_INFO_FOOD_NAV_I,
  FIRST_STEPS_PLS_ACPT_TERMS,
  DAILY_RECOMMENDED_CALORIES,
  BLOG_PREVIEW_FORM_SUECURE,
  BLOG_PREVIEW_FORM_NO_SPAM,
  BLOG_PREVIEW_FORM_SIGN_UP,
  CALC_PAGE_FIRST_CALC_TEXT,
  NUTRITION_FEATURES_RESORS,
  NUTRITION_FEATURES_AMOUNT,
  NUTRITION_FEATURES_HOW_TO,
  NUTRITION_FEATURES_MACROS,
  HLTH_COACH_PRICE_TIN_TEXT,
  HLTH_COACH_PRICE_III_TEXT,
  HLTH_COACH_HELP_DR_HRISTO,
  HLTH_COACH_FEAT_AUTO_WORK,
  DIABETICS_APP_GET_TO_KNOW,
  DIABETICS_APP_TRANSPARENT,
  DIABETICS_APP_SECURE_TEXT,
  HOME_CONSULT_DESC_MED_PRO,
  HOME_CONSULT_DESC_NO_SPAM,
  INDEX_DIABETES_SUGAR_DEAD,
  INDEX_DIABETES_DEAD_COUNT,
  INDEX_CALC_REWIEW_URL_III,
  INDEX_CALC_TOOLS_FOR_HELP,
  INDEX_CALC_INFO_FOUR_FREE,
  FIRST_STEPS_FORM_UR_EMAIL,
  FIRST_STEPS_PLS_VAL_EMAIL,
  RECOMMENDATION_UNDER_18_5,
  SPECIALIST_SUB_USE_TERMS,
  BLOG_PREVIEW_FORM_U_WANT,
  CALC_PAGE_WIGHT_PROBLEMS,
  GI_CALC_PICK_CARBS_FOR_U,
  NUTRITION_CONTAINER_TEXT,
  NUTRITION_CONTAINER_TITE,
  CAL_CALC_FEAT_CAL_INTAKE,
  CAL_CALC_FEAT_LEARN_MORE,
  HLTH_COACH_PRICE_II_TEXT,
  HLTH_COACH_PRICE_IV_TEXT,
  HLTH_COACH_HELP_HELP_PPL,
  HLTH_COACH_FEAT_NEW_PACI,
  HLTH_COACH_FEAT_SCHEDULE,
  HLTH_COACH_HEADER_PROFIT,
  DIABETICS_APP_CONVENIENT,
  DIABETICS_OC_EASY_ACCESS,
  DIABETICS_HIW_EASY_STEPS,
  INDEX_DIABETES_DIAGNOSED,
  INDEX_CALC_REWIEW_URL_II,
  INDEX_CALC_INFO_CAL_CALC,
  INDEX_CALC_INFO_SEE_MORE,
  FIRST_STEPS_FORM_UR_NAME,
  CALORIE_CALCULATOR_TITLE,
  RECOMMENDATION_OVER_39_9,
  INPUT_SEARCH_PLACEHOLDER,
  INDEX_BLOG_WRPR_HLP_FR_U,
  CALC_PAGE_CAL_CALC_TEXT,
  CALC_PAGE_CALCS_EXPLAIN,
  BMI_FEAT_PERFECT_WEIGHT,
  HLTH_COACH_PRICE_I_TEXT,
  DIABETICS_NEWSLTTR_FREE,
  DIABETICS_NEWSLTTR_TIPS,
  DIABETICS_APP_EASY_TEXT,
  DIABETICS_HIW_PIC_A_PRO,
  INDEX_HERO_HERE_TO_HELP,
  INDEX_HERO_NEW_DIAGNOSE,
  INDEX_DIABETES_AFFECTED,
  INDEX_CALC_REWIEW_URL_I,
  FIRST_STEPS_RM_TNX_BETA,
  FIRST_STEPS_FORM_SUBMIT,
  BLOG_PREVIEW_FORM_FREE,
  BLOG_PREVIEW_FORM_ANON,
  GI_CALC_WHAT_ARE_CARBS,
  CAL_CALC_FEAT_WHAT_CAL,
  CAL_CALC_FEAT_CAL_BURN,
  BMI_FEAT_EXSAMPLE_EASY,
  HLTH_COACH_HELP_PROFIT,
  HLTH_COACH_FEAT_ONLINE,
  HLTH_COACH_HEADER_DESC,
  DIABETICS_APP_INDV_SEG,
  DIABETICS_OC_SYNC_TEXT,
  DIABETICS_HIW_AIC_TEXT,
  DIABETICS_HIW_PAP_TEXT,
  HOME_CONSULT_DESC_TEXT,
  HOME_CONSULT_DESC_FREE,
  HOME_CONSULT_DESC_ANON,
  INDEX_HERO_FIRST_STEPS,
  INDEX_CALC_REWIEW_IVET,
  FIRST_STEPS_FORM_TERMS,
  FIRST_STEPS_RM_TNX_MSG,
  AVERAGE_GLYCEMIC_INDEX,
  SEATED_MOST_OF_THE_DAY,
  CONSTANTLY_ON_THE_MOVE,
  SPECILIST_SUB_WRAPPER,
  BLOG_PREVIEW_FORM_RES,
  BLOG_PREVIEW_FORM_PDF,
  CALC_PAGE_STEP_MACROS,
  CAL_CALC_FEAT_USEFULL,
  BMI_FEAT_USE_EFECTIVE,
  DIABETICS_APP_NO_CASH,
  DIABETICS_OC_ESF_TEXT,
  HOME_CONSULT_DESC_PDF,
  INDEX_HERO_FREE_GUIDE,
  INDEX_CALC_REWIEW_JAY,
  INDEX_CALC_TOOLS_DESC,
  SPECIALIST_SUB_EMAIL,
  SPECIALIST_SUB_ABOUT,
  SPECIALIST_SUB_TERMS,
  CALC_PAGE_FIRST_CALC,
  CALC_PAGE_LOSE_KILOS,
  CALC_PAGE_KEEP_KILOS,
  CALC_PAGE_GAIN_KILOS,
  CALC_PAGE_STEP_INDEX,
  BMI_FEAT_WHAT_IS_ITM,
  BMI_HEADER_MAIN_TEXT,
  HLTH_COACH_FEAT_RATE,
  DIABETICS_APP_SECURE,
  DIABETICS_OC_EA_TEXT,
  DIABETICS_OC_SIGN_UP,
  INDEX_DIABETES_SUGAR,
  INDEX_CALC_REWIEW_YI,
  INDEX_HLTH_LIFE_DESC,
  INDEX_CALC_INFO_FREE,
  FIRST_STEPS_FORM_AND,
  SPECILIST_SUB_ABOUT,
  SPECIALIST_SUB_NAME,
  SPECIALIST_SUB_TEAM,
  SPECIALIST_SUB_SEND,
  CALC_PAGE_U_ARE_NEW,
  CALC_PAGE_U_ARE_OLD,
  GI_CALC_USEFULL_RES,
  GI_CALC_LEARN_CARBS,
  GI_CALC_HIGH_LOW_GL,
  CAL_CALC_FEAT_TYPES,
  CAL_CALC_FEAT_SORCE,
  BMI_FEAT_HOW_TO_ITM,
  BMI_FEAT_HOW_TO_USE,
  HLTH_COACH_HELP_DOC,
  INDEX_DIABETES_DESC,
  INDEX_DIABETES_DEAD,
  INDEX_CALC_INFO_BMI,
  FIRST_STEPS_FORM_FS,
  FIRST_STEPS_REQ_FLD,
  SLIDER_VALUE_2_TEXT,
  SLIDER_VALUE_0_TEXT,
  WHAT_IS_YOUR_HEIGHT,
  WHAT_IS_YOUR_WEIGHT,
  CONTACT_WITH_EXPERT,
  MORE_ADVICES_BUTTON,
  WHAT_IS_YOUR_GENDER,
  HIGH_GLYCEMIC_INDEX,
  SLIDER_VALUE_1_TEXT,
  SPECIALIST_SUB_AND,
  SPECIALIST_SUB_MSG,
  SPECIALIST_SUB_ACS,
  CALC_PAGE_MAX_HELP,
  CALC_PAGE_CAL_CALC,
  CALC_PAGE_STEP_CAL,
  CALC_PAGE_TEXT_III,
  GI_CALC_LEARN_MORE,
  GI_CALC_PICK_CARBS,
  GI_CALC_FOOD_CATEG,
  BMI_FEAT_READ_MORE,
  BMI_FEAT_ITM_FLAWS,
  DIABETICS_APP_DESC,
  DIABETICS_APP_EASY,
  FOOTER_ABOUT_COMNY,
  FOOTER_HELP_CENTRE,
  FOOTER_DOC_NETWORK,
  INDEX_CALC_STORIES,
  HEADER_CALCULATORS,
  LOW_GLYCEMIC_INDEX,
  GET_RESULTS_BUTTON,
  TABS_SECTION_TITLE,
  FOOD_SEARCH_BUTTON,
  GLYCEMIC_INDEX_TAB,
  PAGE_NOT_HOME_PAGE,
  INPUT_SEARCH_TITLE,
  NUTRITION_URI_III,
  CALC_PAGE_WELCOME,
  CALC_PAGE_TEXT_II,
  CALC_PAGE_TEXT_IV,
  GI_CALC_GL_ENOUGH,
  CAL_CALC_SUB_TEXT,
  CAL_CALC_FEAT_QAL,
  BMI_FEAT_EXSAMPLE,
  DIABETICS_OC_SYNC,
  FOOTER_CONTACT_US,
  GLYCEMIC_INDEX_OF,
  GLYCEMIC_LOAD_TAB,
  NUTRITION_URI_II,
  NUTRITION_URI_IV,
  CAL_CALC_URL_III,
  BMI_FEAT_URL_III,
  CALC_PAGE_TEXT_I,
  CALC_PAGE_TEXT_V,
  GL_CALC_SUB_TEXT,
  FOOTER_DIABETICS,
  GLYCEMIC_LOAD_OF,
  RECOMMENDED_TEXT,
  WHAT_IS_YOUR_AGE,
  CALCULATE_BUTTON,
  NUTRITION_URI_I,
  GI_CALC_URL_III,
  CAL_CALC_URL_II,
  CAL_CALC_URL_IV,
  BMI_FEAT_URL_II,
  BMI_FEAT_URL_IV,
  SUB_FORM_U_WANT,
  CALC_PAGE_CALCS,
  CALC_PAGE_STEPS,
  BLOG_CATEGORIES,
  NUTRITION_INPUT,
  BMI_FEAT_MESURE,
  BMI_HEADER_MASS,
  BMI_HEADER_CALC,
  FOOTER_ABOUT_US,
  FOOTER_SERVICES,
  FOOTER_PODCASTS,
  HEADER_DIABETIC,
  GI_CALC_URL_II,
  GI_CALC_URL_IV,
  CAL_CALC_URL_I,
  BMI_FEAT_URL_I,
  NUTRITION_TEXT,
  CAL_CALC_TITLE,
  BLOG_MOST_READ,
  FOOTER_CARIERS,
  FOOTER_PRIVACY,
  FOOTER_COOKIES,
  HEADER_DOCTORS,
  PAGE_NOT_FOUND,
  PER_SERVING_OF,
  SLIDER_VALUE_1,
  SLIDER_VALUE_2,
  SLIDER_VALUE_0,
  GI_CALC_URL_I,
  SUB_FORM_DESC,
  GI_CALC_CARBS,
  GL_CALC_TITLE,
  CAL_CALC_TEXT,
  BMI_EMAIL_SCS,
  BMI_EMAIL_INV,
  BMI_EMAIL_USD,
  DIABETICS_HIW,
  CARBOHYDRATES,
  SECTION_TITLE,
  GL_CALC_TEXT,
  BMI_FEAT_RES,
  FOOTER_LEGAL,
  FOOTER_TERMS,
  FOOTER_TOOLS,
  FOOTER_HELP,
  FOOTER_BLOG,
  HEADER_BLOG,
  HEADER_MAIN,
  YEARS_POPUP,
  FOOTER_FAQ,
  FEET_POPUP,
  FOOD_DRINK,
  BLOG_NEW,
  LBS_INCH,
  KG_POPUP,
  SM_POPUP,
  LB_POPUP,
  MY_UNITS,
  IMPERIAL,
  BMI_BMI,
  GLUCOSE,
  PORTION,
  METRIC,
  FEMALE,
  HEIGHT,
  WEIGHT,
  KG_BMI,
  YEARS,
  KG_CM,
  MALE,
  INCH,
  GRAM,
  FEET,
  LBS,
  CM,
  GI,
  SM,
  GL,
  KG,
  LB,
}
